// import '../../node_modules/slick-carousel/slick/ajax-loader.gif';
import '../../node_modules/slick-carousel/slick/slick';
import '../scss/slick.scss';

(function($) {

    $(document).on('ready', () => {
        
        // $('.scientifica-testimonial-slider').slick();

    })

})(jQuery)